'use client';

import { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';

/** Persist the complete current query for links using useInheritParams. */
export function useSessionParamSync(): void {
    const searchParams = useSearchParams();

    useEffect(() => {
        const paramStr = searchParams.toString();
        try {
            if (paramStr) {
                window.sessionStorage.setItem('paramStr', paramStr);
            } else {
                window.sessionStorage.removeItem('paramStr');
            }
        } catch (e) {
            console.error(e);
        }
    }, [searchParams]);
}
